<template>
  <Layout class="img-wrapper">
    <img src="@/assets/images/ok.jpg" width="236" height="236" alt />
    <Alert type="success" show-icon>
      <template slot="desc">
        您的此次上门服务已完成，如需其他帮助，请关注
        <a href="http://www.dell.com.cn">www.dell.com.cn</a>
      </template>
    </Alert>
    <div style="text-align:center;">
      <a class="record" target="_blank" href="http://www.beian.miit.gov.cn">粤ICP备09026986号</a>
    </div>
  </Layout>
</template>

<script>
export default {}
</script>

<style lang="scss" scope>
a {
  color: white;
  text-decoration: underline;
}
.record {
  display: inline-block;
  color: #000;
  text-align: center;
  text-decoration: none;
}
.record:hover {
  color: #000;
}
</style>
